import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

// No custom components needed for this schema

export default defineType({
  name: 'centeringRingsConfiguration',
  title: 'Centering Rings Configuration',
  type: 'document',
  fields: [
    defineField({
      name: 'name',
      title: 'Configuration Name',
      type: 'string',
      validation: (rule) => rule.required(),
    }),
    defineField({
      title: 'None Warning Message',
      name: 'noneWarningMessage',
      type: 'array',
      of: strongEmLink,
    }),
    defineField({
      title: 'Do I need Modal',
      name: 'modal',
      type: 'reference',
      to: [{ type: 'modal' }],
    }),
    defineField({
      title: 'Important Message',
      name: 'importantMessage',
      type: 'array',
      of: strongEmLink,
    }),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare({ title = 'New Configuration' }) {
      return {
        title,
        subtitle: 'Centering Rings Configuration',
      }
    },
  },
})
